<template>
	<div class="select-companion">
		<div class="select__container">
			<label class="select__label">
				<span v-if="label != ''" class="select__label-text">{{ label }}</span>
				<select
					:class="[
						'formtext',
						'select',
						label ? 'select--with-label' : true,
						lightTheme ? 'select--lightTheme' : '',
						small ? 'select--small' : true,
						value > 0 ? 'select--selected' : '',
						hasError ? 'select--error' : ''
					]"
					:disabled="isDisabled"
					@change="emit($event.target.value)"
				>
					<option
						:disabled="this.defaultDisabled"
						:selected="product.addrlid ? false : true"
						:value="''"
					>
						{{ $t('cart.selectCompanionPlaceholder') }}
					</option>
					<option
						v-for="guest in guestList()"
						:value="guest.guestlid"
						:key="guest.guestlid"
						:selected="isSelected(guest)"
						:disabled="!isValidAge(guest)"
					>
						{{ `${guest.name} ${guest.lastname}` }}
					</option>
					<option :value="'NEW'" :selected="showCreate">
						{{ $t('cart.addNewCompanion') }}
					</option>
				</select>

				<span>
					<svg width="14" height="7" viewBox="0 0 14 7" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M7 7a.998.998 0 01-.64-.232l-6-5A1.001 1.001 0 011.64.232l5.36 4.466L12.358.232a1.001 1.001 0 011.282 1.536l-6 5a.998.998 0 01-.64.232" fill-rule="evenodd"/></svg>
				</span>
			</label>

			<Button
				v-if="showEdit && !isDisabled"
				@click.native="showEditModal = true"
				size="small"
				color="dark"
				class="select-companion__button"
			>
				{{ $t('companion.edit') }}
			</Button>

			<Button
				v-if="showCreate"
				@click.native="showCreateModal = true"
				size="small"
				class="select-companion__button"
			>
				{{ $t('companion.create') }}
			</Button>
		</div>

		<!-- Edit guest -->
		<Modal v-if="showEditModal" @close="showEditModal = false" :maxWidth="640">
			<Guest_Form
				:edit="true"
				:guestType="productType"
				:photoMandatory="product.photoMandatory"
				:modalView="true"
				:guestlid="parseInt(selectedGuestlid)"
				@close="closeEdit"
			/>
		</Modal>

		<!-- Create guest -->
		<Modal
			v-if="showCreateModal"
			@close="showCreateModal = false"
			:maxWidth="640"
		>
			<Guest_Form
				:guestType="productType"
				:photoMandatory="product.photoMandatory"
				@close="closeEdit"
				:modalView="true"
				@set-guest="
					val => {
						currentGuest(val)
					}
				"
			/>
		</Modal>
	</div>
</template>

<script>
import Button from '../atoms/Button'
import Modal from '../molecules/Modal'
import Guest_Form from '../organisms/forms/Guest_Form'
import moment from 'moment'
import store from '../../vueX/store'

export default {
	name: 'SelectCompanion',
	components: {
		Button,
		Modal,
		Guest_Form
	},
	data: () => {
		return {
			showEdit: false,
			showCreate: false,
			showEditModal: false,
			showCreateModal: false,
			showAgeError: false,
			showMandetoryDataError: false,
			selectedGuestlid: ''
		}
	},
	props: {
		value: {
			type: String,
			default: ''
		},
		optionItems: {
			type: Array,
			default: () => []
		},
		defaultSelectedValue: {
			type: String,
			default: ''
		},
		defaultDisabled: {
			type: Boolean,
			default: false
		},
		lightTheme: {
			type: Boolean,
			default: true
		},
		small: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			default: ''
		},
		isDisabled: {
			type: Boolean,
			default: false
		},
		product: {
			type: Object,
			default: () => {}
		},
		selectedGuset: {
			type: Object,
			default: () => {}
		},
		productType: {
			type: String,
			default: ''
		},
		hasError: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		guests() {
			if (store.state.user != null) {
				return store.state.user.guests
			}
			return []
		},
		skipasses() {
			return store.state.cart.skipasses
		}
	},
	created() {},
	methods: {
		isValidAge(guest) {
			const end = this.product.endDate
				? moment(this.product.endDate)
				: moment(this.product.startDate)
			const age = end.diff(guest.birthdate, 'years')
			return age >= this.product.fromAge && age <= this.product.toAge
		},
		isValidData(guest) {
			return guest.length > 0 && guest.shoesize > 0 && guest.weight > 0
		},
		isSelected(guest) {
			if (parseInt(this.product.addrlid) == guest.guestlid) {
				this.showEdit = true
				this.selectedGuestlid = guest.guestlid
				this.showAgeError = !this.isValidAge(guest)
				this.showMandetoryDataError =
					this.productType == 'skirental' ? !this.isValidData(guest) : false
				return true
			} else {
				return false
			}
		},
		currentGuest(val) {
			const stringId = val.toString()
			this.emit(stringId)
		},
		closeEdit() {
			this.showEditModal = false
			this.showCreateModal = false
			// Validate after select if checkout have been klicked
			if (store.state.cart.cartCheckoutClicked) {
				store.dispatch('VALIDATE_PRODUCTS_IN_CART')
			}
		},
		emit(val) {
			const actionName =
				'CHANGE_CART_' + this.productType.toUpperCase() + '_GUEST'
			const productKey = this.productType.toString()

			//When selecting placeholder option
			if (val == '') {
				this.showEdit = false
				this.showAgeError = false
				this.showMandetoryDataError = false

				//Clear the cart from guestlid-value
				store.dispatch(actionName, {
					[productKey]: this.product,
					guestlid: ''
				})

				//When selecting "add a new guest"
			} else if (val == 'NEW') {
				this.showCreate = true
				this.showEdit = false
				this.showAgeError = false
				this.showMandetoryDataError = false

				//Prepare the cart with an empty guestlid-value on the product
				store.dispatch(actionName, {
					[productKey]: this.product,
					guestlid: ''
				})

				//When selecting an existing guest OR auto selecting of the new guest (after create guest modal)
			} else {
				this.showEdit = true
				this.showCreate = false
				this.selectedGuestlid = val

				//Link guest to product in cart
				store.dispatch(actionName, {
					[productKey]: this.product,
					guestlid: val
				})
			}

			// Validate after select if checkout have been klicked
			if (store.state.cart.cartCheckoutClicked) {
				store.dispatch('VALIDATE_PRODUCTS_IN_CART')
			}
		},
		guestList() {
			if (this.guests != null) {
				return this.guests.filter(each => each.age)
			} else {
				return []
			}
		}
	}
}
</script>

<style scoped lang="scss">
.select-companion__button {
	margin-left: 10px;
}
.select__container {
	display: flex;
}
.select__label {
	display: flex;
	flex-wrap: wrap;
	position: relative;
	width: 100%;
	max-width: 337px;

	&-text {
		display: block;
		color: #697791;
		font-family: Saira;
		font-size: 15px;
		line-height: 24px;
		margin-bottom: 5px;
	}
}
.select__error {
	color: $colorRed;
	display: block;
	font-size: 15px;
	line-height: 15px;
	margin-top: 15px;
	color: #e15b5b;
}
.select {
	cursor: pointer;
	outline: 0;
	background: $colorInputBackground;
	border: 0;
	border-radius: 5px;
	color: $colorInputText;
	padding: 0 50px 0px 12px;
	height: $input-field-height;
	@include for-tablet-portrait-up {
		font-size: 16px;
		line-height: 33px;
	}
	min-width: 100px;
	width: 100%;
	appearance: none;
	-moz-appearance: none;
	-webkit-appearance: none;

	&::-ms-expand {
		display: none;
	}

	&::placeholder {
		font-weight: 300;
		color: #7f8ba1;
	}

	&:disabled {
		background: $colorGrey1;
		cursor: context-menu;
	}
	&:disabled::placeholder {
		color: $colorPrimary3;
	}
	&:disabled + span {
		svg {
			fill: $colorPrimary3;
		}
	}
	+ span {
		position: absolute;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 50px;
		height: $input-field-height;
		@include for-tablet-portrait-up {
			width: 46px;
		}
		background: $colorPrimary2;
		right: 0;
		pointer-events: none;
		border-radius: 0 5px 5px 0;
		svg {
			width: 14px;
			height: 11px;
			fill: $colorWhite;
		}
	}

	option:disabled {
		color: #ccc;
	}

	&--with-label {
		+ span {
			top: 29px;
		}
	}
	&--lightTheme {
		background: $colorWhite;
		border: 1px solid $colorPrimary3;
		+ span {
			background: transparent;
			svg {
				fill: $colorPrimary3;
			}
		}
	}
	// &:disabled {
	// 	border-color: $colorPrimary3;
	// 	color: $colorPrimary5;
	// }
	&--error {
		color: $colorWhite;
		border-color: $colorAltRed;
		background: $colorRed;
	}
	&--error + span {
		background: $colorAltRed;
		svg {
			fill: $colorWhite;
		}
	}
	&--small {
		height: 35px;
		padding: 0 35px 0 15px;
		font-size: 16px;
		+ span {
			width: 35px;
			height: 35px;
		}
	}
}
</style>
